__turbopack_context__.v({
  "border": "Card-module__i27XrG__border",
  "card": "Card-module__i27XrG__card",
  "centered": "Card-module__i27XrG__centered",
  "clickable": "Card-module__i27XrG__clickable",
  "elevated": "Card-module__i27XrG__elevated",
  "fullHeight": "Card-module__i27XrG__fullHeight",
  "fullWidth": "Card-module__i27XrG__fullWidth",
  "rounded": "Card-module__i27XrG__rounded",
  "selected": "Card-module__i27XrG__selected",
});
